// import React, { useRef, useState } from 'react';
// import ReCAPTCHA from 'react-google-recaptcha';

// const Input = () => {
//     const formRef = useRef<HTMLFormElement>(null);
//     const iframeRef = useRef<HTMLIFrameElement>(null);

//     const emailRef = useRef<HTMLInputElement>(null);
//     const firstNameRef = useRef<HTMLInputElement>(null);
//     const lastNameRef = useRef<HTMLInputElement>(null);

//     const [loading, setLoading] = useState(false);
//     const [showModal, setShowModal] = useState(false);
//     const [captchaVerified, setCaptchaVerified] = useState(false);
//     const [captchaError, setCaptchaError] = useState(false);

//     const handleClick = () => {
//         if (!captchaVerified) {
//             setCaptchaError(true);
//             return;
//         }

//         if (
//             formRef.current &&
//             emailRef.current &&
//             firstNameRef.current &&
//             lastNameRef.current
//         ) {
//             if (emailRef.current.value) {
//                 setLoading(true);
//                 formRef.current.submit();
//                 emailRef.current.value = '';
//                 firstNameRef.current.value = '';
//                 lastNameRef.current.value = '';
//                 setCaptchaError(false);
//             }
//         }
//     };

//     const handleCaptchaChange = (token: string | null) => {
//         setCaptchaVerified(!!token);
//         setCaptchaError(false);
//     };

//     const handleIframeLoad = () => {
//         if (loading) {
//             setLoading(false);
//             setShowModal(true);
//         }
//     };

//     return (
//         <>
//             {/* Mailchimp form */}
//             <form
//                 ref={formRef}
//                 action="https://sporthub.us20.list-manage.com/subscribe/post?u=2f9452690b89647ce0bca7883&amp;id=efdfdc211b&amp;f_id=0011d0e5f0"
//                 method="post"
//                 target="hidden_iframe"
//                 className="w-full"
//             >
//                 <div className="flex flex-col sm:flex-col items-stretch gap-3 mb-3 animate-fade-in-up delay-[2700ms]">
//                     <div className='flex lg:flex-row flex-col items-center gap-3'>
//                         <input
//                             type="text"
//                             name="FNAME"
//                             id="mce-FNAME"
//                             ref={firstNameRef}
//                             placeholder="Enter your first name"
//                             className="flex-1 px-4 py-3 rounded-md border border-gray-600 bg-black/20 backdrop-blur-sm text-white placeholder-gray-400 outline-none focus:border-teal-400 transition-colors"
//                         />
//                         <input
//                             type="text"
//                             name="LNAME"
//                             id="mce-LNAME"
//                             ref={lastNameRef}
//                             placeholder="Enter your last name"
//                             className="flex-1 px-4 py-3 rounded-md border border-gray-600 bg-black/20 backdrop-blur-sm text-white placeholder-gray-400 outline-none focus:border-teal-400 transition-colors"
//                         />
//                     </div>

//                     <div className='flex flex-col gap-3'>
//                         <input
//                             type="email"
//                             name="EMAIL"
//                             id="mce-EMAIL"
//                             ref={emailRef}
//                             placeholder="Enter your Email"
//                             required
//                             className="w-full px-4 py-3 rounded-md border border-gray-600 bg-black/20 backdrop-blur-sm text-white placeholder-gray-400 outline-none focus:border-teal-400 transition-colors"
//                         />

//                         {/* reCAPTCHA below email */}
//                         <div>
//                             <ReCAPTCHA
//                                 sitekey="6LfEIVwrAAAAAEP-obnmYr9T5bPBqOGsIElW8HTQ"
//                                 onChange={handleCaptchaChange}
//                             />
//                             {captchaError && (
//                                 <p className="text-red-500 text-sm mt-1">Please verify you are not a robot.</p>
//                             )}
//                         </div>

//                         <div className="mt-2">
//                             <button
//                                 type="button"
//                                 onClick={handleClick}
//                                 disabled={loading}
//                                 className={`w-full px-5 py-3 rounded-md transition ${loading
//                                     ? 'bg-gray-500 cursor-not-allowed'
//                                     : 'bg-red-600 hover:bg-red-700'
//                                     } text-white`}
//                             >
//                                 {loading ? 'Submitting...' : 'Join the Waitlist'}
//                             </button>
//                         </div>
//                     </div>
//                 </div>

//                 {/* Anti-bot hidden field */}
//                 <div style={{ position: 'absolute', left: '-5000px' }} aria-hidden="true">
//                     <input type="text" name="b_2f9452690b89647ce0bca7883_efdfdc211b" tabIndex={-1} defaultValue="" />
//                 </div>
//             </form>

//             {/* Hidden Iframe for response */}
//             <iframe
//                 name="hidden_iframe"
//                 ref={iframeRef}
//                 onLoad={handleIframeLoad}
//                 style={{ display: 'none' }}
//                 title="hidden_iframe"
//             ></iframe>

//             {/* Success Modal */}
//             {showModal && (
//                 <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
//                     <div className="bg-white p-6 rounded-lg max-w-sm w-full text-center shadow-lg">
//                         <h2 className="text-xl font-bold text-green-600 mb-3">Success!</h2>
//                         <p className="text-gray-700">You've joined the waitlist successfully.</p>
//                         <button
//                             onClick={() => setShowModal(false)}
//                             className="mt-4 px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded"
//                         >
//                             Close
//                         </button>
//                     </div>
//                 </div>
//             )}
//         </>
//     );
// };

// export default Input;




import React, { useRef, useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

const Input = () => {
    const formRef = useRef<HTMLFormElement>(null);
    const iframeRef = useRef<HTMLIFrameElement>(null);

    const emailRef = useRef<HTMLInputElement>(null);
    const firstNameRef = useRef<HTMLInputElement>(null);
    const lastNameRef = useRef<HTMLInputElement>(null);

    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [captchaVerified, setCaptchaVerified] = useState(false);
    const [captchaError, setCaptchaError] = useState(false);

    const handleClick = () => {
        if (!captchaVerified) {
            setCaptchaError(true);
            return;
        }

        if (
            formRef.current &&
            emailRef.current &&
            firstNameRef.current &&
            lastNameRef.current
        ) {
            if (emailRef.current.value) {
                setLoading(true);
                formRef.current.submit();
                emailRef.current.value = '';
                firstNameRef.current.value = '';
                lastNameRef.current.value = '';
                setCaptchaError(false);
            }
        }
    };

    const handleCaptchaChange = (token: string | null) => {
        setCaptchaVerified(!!token);
        setCaptchaError(false);
    };

    const handleIframeLoad = () => {
        if (loading) {
            setLoading(false);
            setShowModal(true);
        }
    };

    return (
        <>
            <form
                ref={formRef}
                action="https://sporthub.us20.list-manage.com/subscribe/post?u=2f9452690b89647ce0bca7883&amp;id=efdfdc211b&amp;f_id=0011d0e5f0"
                method="post"
                target="hidden_iframe"
                className="w-full max-w-xl mx-auto px-4"
            >
                <div className="flex flex-col items-stretch gap-4 mb-4 animate-fade-in-up delay-[2700ms]">
                    <div className="flex flex-col sm:flex-row sm:flex-wrap gap-3">
                        <input
                            type="text"
                            name="FNAME"
                            id="mce-FNAME"
                            ref={firstNameRef}
                            placeholder="Enter your first name"
                            className="w-full sm:flex-1 px-4 py-3 rounded-md border border-gray-600 bg-black/20 backdrop-blur-sm text-white placeholder-gray-400 outline-none focus:border-teal-400 transition-colors"
                        />
                        <input
                            type="text"
                            name="LNAME"
                            id="mce-LNAME"
                            ref={lastNameRef}
                            placeholder="Enter your last name"
                            className="w-full sm:flex-1 px-4 py-3 rounded-md border border-gray-600 bg-black/20 backdrop-blur-sm text-white placeholder-gray-400 outline-none focus:border-teal-400 transition-colors"
                        />
                    </div>

                    <input
                        type="email"
                        name="EMAIL"
                        id="mce-EMAIL"
                        ref={emailRef}
                        placeholder="Enter your Email"
                        required
                        className="w-full px-4 py-3 rounded-md border border-gray-600 bg-black/20 backdrop-blur-sm text-white placeholder-gray-400 outline-none focus:border-teal-400 transition-colors"
                    />

                    <div className="w-full">
                        <ReCAPTCHA
                            sitekey="6LfEIVwrAAAAAEP-obnmYr9T5bPBqOGsIElW8HTQ"
                            onChange={handleCaptchaChange}
                        />
                        {captchaError && (
                            <p className="text-red-500 text-sm mt-1">Please verify you are not a robot.</p>
                        )}
                    </div>

                    <button
                        type="button"
                        onClick={handleClick}
                        disabled={loading}
                        className={`w-full px-5 py-3 rounded-md transition ${loading
                            ? 'bg-gray-500 cursor-not-allowed'
                            : 'bg-red-600 hover:bg-red-700'
                            } text-white`}
                    >
                        {loading ? 'Submitting...' : 'Join the Waitlist'}
                    </button>
                </div>

                {/* Anti-bot hidden field */}
                <div style={{ position: 'absolute', left: '-5000px' }} aria-hidden="true">
                    <input type="text" name="b_2f9452690b89647ce0bca7883_efdfdc211b" tabIndex={-1} defaultValue="" />
                </div>
            </form>

            <iframe
                name="hidden_iframe"
                ref={iframeRef}
                onLoad={handleIframeLoad}
                style={{ display: 'none' }}
                title="hidden_iframe"
            ></iframe>

            {showModal && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
                    <div className="bg-white p-6 rounded-lg max-w-sm w-full text-center shadow-lg">
                        <h2 className="text-xl font-bold text-green-600 mb-3">Success!</h2>
                        <p className="text-gray-700">You've joined the waitlist successfully.</p>
                        <button
                            onClick={() => setShowModal(false)}
                            className="mt-4 px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded"
                        >
                            Close
                        </button>
                    </div>
                </div>
            )}
        </>
    );
};

export default Input;
